import './Tab.css';

import classNames from 'classnames';
import React from 'react';

const Tab = ({ className, labels, selected, onSelectTab = () => {} }) => {
    const changeTab = (index) => {
        onSelectTab(index);
    };

    return (
        <nav className={classNames('tab', className)}>
            <ul>
                {labels.map((label, index) => (
                    <li key={index} className={classNames('tab-item', { selected: selected === index })}>
                        <button onClick={() => changeTab(index)}>
                            {label}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Tab;
